// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bie_vu bie_ql bie_va bie_gy bie_kg bie_sv","ProfileAdminTools__item":"iz_b"};